import React from "react"
import styled from "styled-components"
import Social from "./social";
import MenuFooter from "./menuFooter";
import Contacts from "./contacts";

import { menu_1, menu_2, contacts as contact_info} from './data/footer'

const Container = styled.footer`
  background-color: var(--cPrimary);
  color: var(--cText);
  display: block;
  width: 100%;
  font-family: 'Be Vietnam', 'Roboto', sans-serif;
  padding-top: 60px;
  @media(min-width: 920px) {
    padding-top: 100px;
  }
  /* margin-top: 100px; */
`
const Content = styled.div`
  
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 60px;
  padding-bottom: 60px;
  justify-content: center;
  @media(min-width: 920px) {
    padding-bottom: 100px;
  }
  @media (min-width: 646px){
    display: grid;
    grid-template-columns: 130px 130px 638px;
    grid-gap: 60px;
    justify-content: space-between;
  }
 
`
const Copy = styled.div`
  /* border-top: 1px solid #3d78ff; */
  padding: 35px 0;
  font-weight: 400;
  font-size: 0.8rem;
  /* margin-top: 20px; */
  background-color: #FFF;
  color: var(--cPrimaryDark);

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    @media (min-width: 845px){
      justify-content: space-between;
    }
    p {
      text-align: center;
      @media (min-width: 845px){
        text-align: left;
      }
      
    }
  }
`
const Footer = () => (
 <Container>
   <Content className="container">
    <MenuFooter data={menu_1} />
    <MenuFooter data={menu_2} />
    <Contacts data={contact_info} />  
   </Content>
   <Copy>
     <div className="container">
      <p>
        TagPlus CNPJ 10.753.249/0001-21 © 2010 - {new Date().getFullYear()} - Todos os direitos reservados
      </p>
      <Social />
     </div>
    </Copy>
 </Container>
)
export default Footer
